import { baseQuery } from "../../../app/baseQuery";
import { apiTags } from '../../../app/store/apiTags';
import { baseApi } from '../../../app/baseApi';
import { skipToken } from "@reduxjs/toolkit/query";


import FormatService from "services/formatService";
import { VendorInvoiceFileStatusLabels } from "../invoiceConsts.ts";
import { arrayToObject } from 'utils/object-util';

const statusLabelLookup = arrayToObject(VendorInvoiceFileStatusLabels, 'id');
const apiPrefix = '/vendorinvoicefile';
export const vendorInvoiceFilesApi = baseApi.injectEndpoints({
    reducerPath: 'vendorInvoiceFilesApi',
    tagTypes: [apiTags.VENDOR_INVOICE_FILES],
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getAllVendorInvoiceFiles: builder.query({
            query: () => `${apiPrefix}`,
            providesTags: [apiTags.VENDOR_INVOICE_FILES],
            transformResponse: (response) =>
                Array.isArray(response)
                    ? response.map(i => ({
                        ...i,
                        statusLabel: statusLabelLookup[i.status]?.name,
                        createdDate: FormatService.formatDateTime(i.createdDate),
                        receivedDate: FormatService.formatDateTime(i.receivedDate),
                    }))
                    : response,
        }),
        getByVendorInvoiceFileId: builder.query({
            query: (id) => {
                if (id === null || id === undefined) return skipToken;
                return `${apiPrefix}/${id}/output`;
            },
            providesTags: [apiTags.VENDOR_INVOICE_FILES],
        }),
        uploadFiles: builder.mutation({
            query: (files) => {
                const formData = new FormData();
                files.forEach(file => formData.append("files", file));

                return {
                    url: `${apiPrefix}/upload`,
                    method: "POST",
                    body: formData,
                };
            },
            invalidatesTags: [apiTags.VENDOR_INVOICE_FILES],
        }),
    }),
});

export const {
    useGetAllVendorInvoiceFilesQuery,
    useGetByVendorInvoiceFileIdQuery,
    useUploadFilesMutation,
} = vendorInvoiceFilesApi;